module.exports = __webpack_public_path__ + "media/images/pages/home_featured/contributor-overview-get-started-d49d3ab3d0478982d75697839f076d82.png";